import { ADDRESS_INFORMATION_API } from 'constants/AppConstants';

export default async (addressType, addressInfo) => {
  try {
    const queryParams = new URLSearchParams(
      (typeof addressType !== 'object') ? { addressType } : { ...addressType },
    );
    const requestBody = {
      address: addressInfo,
    };
    const response = await fetch(`${ADDRESS_INFORMATION_API}?${queryParams.toString()}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
